module.exports = __webpack_public_path__ + "assets/img/btn-view-99cdd737.png";